<template>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button class="button_back" @click="goBack">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <div class="main_wrapper ion-padding">
    <!-- Show loading screen while user data is being fetched -->
    <div v-if="loading" class="loading-screen">
     
    </div>

    <!-- Show user name when available -->
    <div v-else class="main_text">
      <div class="user_info_wrapper user_info_wrapper-padding">
    <div>
      <img class="user_image" :src="user.image" v-if="user.image" />
        <el-empty class="user_image" v-else></el-empty>
    </div>
        <div class="main-card">
          <div class="image_text_comp">
            <div class="text_wrapper text_wrapper-border">
              <div class="main-card-text">{{ user.name }}</div>
              <div v-if="user.settings.preferredName" class="preferred-name">
                
                <span class="locumate_icons locumate_icon-user2"></span>
                <div class="main-card-additional">Preferred name:</div>
                <span>{{ user.settings.preferredName }}</span> 
              </div>
              <div class="main-card-additional" v-if="user.settings.ahpra">
                <span class="locumate_icons locumate_icon-credit_card"></span>
                {{ user.settings.ahpra + " " + "("+user.settings.ahpraExpDate+")" }}
              </div>
              <div class="main-card-additional">
              <!-- <template v-if="distance">
                <span class="distance">
                  <span class="locumate_icons locumate_icon-cursor"></span>
                  <span>{{ distance }} km</span>
                  <span class="symb_dot"></span>
                </span>
              </template> -->
              <span class="locumate_icons  locumate_icon-location2"></span>
             
                <span>{{ user.address.suburb }}, {{ user.address.state }}</span>
              </div>
            </div>
          </div>

        </div>
        <div class="proof-ins" v-if="user.locumCvs.length > 0">
        <span>CV</span>
        <div class="el-upload-list el-upload-list-custom">
          <div
            class="el-upload-list__item"
            v-for="pro in user.locumCvs"
            :key="pro.url"
          >
            <div class="thumbnail_img el-upload-list--picture-card">
              <img
                src="@/assets/img/default_pdf.svg"
                alt=""
                class="header_logo_text"
              />
              <span class="el-upload-list__item-actions">
                <span
                  class="el-upload-list__item-preview"
                  @click="certPreviewModalOpen(pro)"
                >
                  <i class="el-icon-zoom-in"></i>
                </span>
              </span>
            </div>
          </div>
        </div>
        </div>
        <div class="proof-ins" v-if="user.covidCertPro.length > 0">
        <span>Professional Certification</span>
            <div class="el-upload-list el-upload-list-custom">
              <div class="el-upload-list__item" v-for="(pro) in user.covidCertPro" :key="pro.url">
                <div class="thumbnail_img el-upload-list--picture-card">
                  <div v-if="pro.extension == 'pdf'"> 
                    <img src="@/assets/img/default_pdf.svg" alt="" class="header_logo_text">
                  </div>
                  <div v-else>

                    <img
                    class="el-upload-list__item-thumbnail"
                    :src="pro.url"
                    alt=""
                  />
                  </div>
                  <span class="el-upload-list__item-actions">
                    <span
                      class="el-upload-list__item-preview"
                      @click="certPreviewModalOpen(pro)"
                    >
                      <i class="el-icon-zoom-in"></i>
                    </span>
                  </span>
                </div>
                <div v-if="pro.expiryDate">
                <div class="policy-expire">Policy Expiry</div>
                <div class="expire-date">
                  {{pro.expiryDate}}
                  
                </div>
              </div>
              </div>
            </div>
            
        </div>
          
          <div class="proof-ins" v-if="user.insuranceDocument.length > 0">
            <span>Insurance Documents</span>
              <div class="el-upload-list el-upload-list-custom">
                <div class="el-upload-list__item" v-for="(insurance) in user.insuranceDocument" :key="insurance.url">
                  <div class="thumbnail_img el-upload-list--picture-card">
                    <div v-if="insurance.extension == 'pdf'"> 
                      <img src="@/assets/img/default_pdf.svg" alt="" class="header_logo_text">
                    </div>
                    <div v-else>
                      
                      <img
                      class="el-upload-list__item-thumbnail"
                      :src="insurance.url"
                      alt=""
                    />
                    </div>
                    <span class="el-upload-list__item-actions">
                      <span
                        class="el-upload-list__item-preview"
                        @click="certPreviewModalOpen(insurance)"
                      >
                        <i class="el-icon-zoom-in"></i>
                      </span>
                    </span>
                  </div>
                  <div v-if="insurance.expiryDate">
                    <div class="policy-expire">Policy Expiry</div>
                    <div class="expire-date">
                      {{insurance.expiryDate}}
                      
                    </div>
                  </div>
                </div>
              </div>
             
          </div>
          <div class="proof-ins" v-if="user.otherInsuranceDocument.length > 0">
            <span>Other Insurance Documents</span>
              <div class="el-upload-list el-upload-list-custom">
                <div class="el-upload-list__item" v-for="(otherInsurance) in user.otherInsuranceDocument" :key="otherInsurance.url">
                  <div class="thumbnail_img el-upload-list--picture-card">
                    <div v-if="otherInsurance.extension == 'pdf'"> 
                      <img src="@/assets/img/default_pdf.svg" alt="" class="header_logo_text">
                    </div>
                    <div v-else>
                      
                      <img
                      class="el-upload-list__item-thumbnail"
                      :src="otherInsurance.url"
                      alt=""
                    />
                    </div>
                    <span class="el-upload-list__item-actions">
                      <span
                        class="el-upload-list__item-preview"
                        @click="certPreviewModalOpen(otherInsurance)"
                      >
                        <i class="el-icon-zoom-in"></i>
                      </span>
                    </span>
                  </div>
                  <div v-if="otherInsurance.expiryDate">
                    <div class="policy-expire">Policy Expiry</div>
                    <div class="expire-date">
                      {{otherInsurance.expiryDate}}
                      
                    </div>
                  </div>
                </div>
              </div>
             
          </div>
      </div>
    </div>
  </div>
  <cert-preview-modal
    :modalName="'certPreviewModal'"
    :options="certPreviewModal"
  ></cert-preview-modal>
</template>
  
<script>
import { ref, onBeforeMount,inject, } from 'vue';
import { IonToolbar, IonButton, IonButtons, IonIcon } from '@ionic/vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import { CertPreviewModal } from "@/modals/modals";
export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    "cert-preview-modal": CertPreviewModal
  },
  setup() {
    const $store = useStore();
    const $router = useRouter();
    const $route = useRoute();
    const user = ref({});
    const loading = ref(true); // Initialize loading state to true
    const distance = ref(null);
    const $modals = inject("$modals");
    const goBack = () => {
      $router.push({
        name: 'search',
      });
    };

    const certPreviewModal = ref({
      name: "certPrev",
      file: [],
    });
    const certPreviewModalOpen = (file) => {
      if(file.extension == 'pdf'){
        window.open(file.url, '_blank');
      }else{
     console.log("aaa")
      certPreviewModal.value.file = file;


      $modals.open("certPreviewModal", {
        file: file,
      });

      console.log("end osf posspup")
    }
    };

    onBeforeMount(async () => {
      console.log("iam urgent from view on beforemount");
      try {
        const id = $route.params.userId;
        console.log("🚀 ~ file: ProfileView.vue:74 ~ returnnewPromise ~ id:", id);

        // Make an API request to fetch user data based on 'id'
        const response = await $store.dispatch("GET_PROFILE_USER_INFO", {
          userId: $route.params.userId,
          
        });

        // Update the 'user' ref with the fetched data
        user.value = response.data;

        // Hide the loading screen when user data is available
        loading.value = false;

        console.log("🚀 ~ file: ProfileView.vue:80 ~ .then ~ jobFetchResult:", user.value);
      } catch (error) {
        console.error("Error fetching user data:", error);
        // Hide the loading screen if an error occurs
        loading.value = false;
      }
    });

    return {
      user,
      loading, // Expose loading state to the template
      goBack,
      distance,
      certPreviewModalOpen,
      certPreviewModal,
    };
  },
};
</script>
  

  